import PaymentHistorySection from './PaymentHistorySection';
import { PaymentHistorySectionProps, PaymentHistorySectionValueProps } from './types';

export type { PaymentHistorySectionProps, PaymentHistorySectionValueProps };
export default PaymentHistorySection;
